import React from 'react';
import {Typography, Button} from 'bonprix-design-system';
import {useTextsContext} from '@account/shared-components/providers/TextsProvider';
import Url from '@core/scripts/helper/url.js';
import WithdrawalTracking from '@account/pages/withdrawal/WithdrawalTracking';
import {FormValues} from '@account/pages/withdrawal/WithdrawalForm';

interface ConfirmationViewProps {
    withdrawalData: Omit<FormValues, 'captchaToken'>;
    homeUrl: string;
    myAccountUrl: string;
}

const ConfirmationView = ({withdrawalData, homeUrl, myAccountUrl}: ConfirmationViewProps) => {
    const {texts} = useTextsContext();

    return (
        <>
            <dl className="p-0 my-8">
                <dt className="pb-3">
                    <Typography variant="bonprix-h5">{texts['cus__withdrawal_dataConfirmation_heading']}</Typography>
                </dt>
                {withdrawalData.firstName && (
                    <dd className="flex gap-1 p-0 m-0">
                        <Typography>{texts['cus__firstname']}:</Typography>
                        <Typography variant="body1-bold">{withdrawalData.firstName}</Typography>
                    </dd>
                )}
                {withdrawalData.lastName && (
                    <dd className="flex gap-1 p-0 m-0">
                        <Typography>{texts['cus__surname']}:</Typography>
                        <Typography variant="body1-bold">{withdrawalData.lastName}</Typography>
                    </dd>
                )}
                <dd className="flex gap-1 p-0 m-0">
                    <Typography>{texts['cus__email']}:</Typography>
                    <Typography variant="body1-bold">{withdrawalData.email}</Typography>
                </dd>
                <dd className="flex gap-1 p-0 m-0">
                    <Typography>{texts['cus__orderNumber']}:</Typography>
                    <Typography variant="body1-bold">{withdrawalData.orderNumber}</Typography>
                </dd>
            </dl>

            <div className="grid justify-items-center gap-6 mt-3">
                <Button
                    contentWidth
                    size="large"
                    component="a"
                    href={Url.toAbsolute(homeUrl)}
                    onClick={() => {
                        WithdrawalTracking.trackClickBackToHome();
                    }}
                >
                    {texts['cus__withdrawal_backToHome_button']}
                </Button>

                <Button
                    contentWidth
                    variant="secondary"
                    size="large"
                    component="a"
                    href={Url.toAbsolute(myAccountUrl)}
                    onClick={() => {
                        WithdrawalTracking.trackClickGoToMyAccount();
                    }}
                >
                    {texts['cus__withdrawal_goToMyAccount_button']}
                </Button>
            </div>
        </>
    );
};

export default ConfirmationView;
